import { env } from '../../globals/config/env';

export type AuthConfig = {
  AUTH0_DOMAIN: string;
  AUTH0_AUDIENCE: string;
  AUTH0_CLIENT_ID: string;
  // Dev-gateway-only escape hatch (see Authentication.ts's AuthenticatedUserProvider): when set,
  // Auth0 is skipped entirely and every request uses this token -- a real JWT pre-signed for a
  // fixed dev identity by Panomio.ApiDevGateway's Auth0Mock, which validates it like any other
  // Authorization: Bearer token.
  AUTHENTICATION_TOKEN: string;
};

export const AUTH0_CONFIG: AuthConfig = {
  AUTH0_DOMAIN: env('AUTH0_DOMAIN', 'DOMAIN_NOT_PROVIDED'),
  AUTH0_AUDIENCE: env('AUTH0_AUDIENCE', 'AUDIENCE_NOT_PROVIDED'),
  AUTH0_CLIENT_ID: env('AUTH0_CLIENT_ID', 'CLIENT_ID_NOT_PROVIDED'),
  AUTHENTICATION_TOKEN: env('AUTHENTICATION_TOKEN', ''),
};
